import { axiosInstance } from "../axios-Instance";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../react-query/constants";
import { toast } from "react-toastify";
import { toastOptions } from "../utils";
import { getLoginToken } from "../storage";

async function getBid() {
  const data = await axiosInstance({
    url: "/bids",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

async function getAvailableBids() {
  const data = await axiosInstance({
    url: "/bids/open",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

async function getAllAvailableBids() {
  const data = await axiosInstance({
    url: "/bids/all",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

const createBid = async (formData: any) => {
  const data = await axiosInstance({
    url: "/bids",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const updateBid = async (formData: any) => {
  const data = await axiosInstance({
    url: `/bids/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const deleteBid = async (formData: any) => {
  const data = await axiosInstance({
    url: `/bids/${formData}`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

export function useBid() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.bid],
    queryFn: () => getBid(),
  });
  return data;
}

export function useAvailableBid() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.availableBids],
    queryFn: () => getAvailableBids(),
  });
  return data;
}

export function useAllRounds() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.allRounds],
    queryFn: () => getAllAvailableBids(),
  });
  return data;
}

export function useCreateBid() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => createBid(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.bid]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useUpdateBid() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => updateBid(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.bid]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useDeleteBid() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => deleteBid(formData),
    onSuccess: (data) => {
      toast.success("Bid Deleted Successfully", toastOptions);
      queryClient.invalidateQueries([queryKeys.bid]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}
